module.exports = __webpack_public_path__ + "img/hr-V-L-6-unload-standup-shadow.f73a4e7e.png";